export const getQueryParams = (searchParams, fields) => {
  const params = {};
  fields.forEach((field) => {
    params[field] = searchParams.get(field);
  });
  return params;
};
